import { EMPTY_LIST } from '../../../constants/common'

export function toUserStaffFunctionalRoleSelectOptions(data) {
  const items = Array.isArray(data) ? data : (data?.results ?? EMPTY_LIST)

  return items.map(({ id, name }) => ({ label: name, value: id }))
}
